import initialState from '../store/initialState'
import tagsTypes from '../constants/tagsTypes'
import preferencesTypes from '../constants/preferencesTypes'

export default function tagsReducer(state = initialState.tags, action) {
  switch (action.type) {

    case tagsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case tagsTypes.reset_tag: {
      return {
        ...initialState.tags,
        items: state.items,
        tag: state.tag,
        errors: []
      }
    }

    // INDEX
    case tagsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case tagsTypes.index.success:
    case preferencesTypes.update.success:
    case preferencesTypes.index.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.tags,
        // pagination: action.payload.pagination,
        errors: []
      }
    }

    case tagsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    case tagsTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case tagsTypes.create.success: {

      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        items: action.payload.tags,
        errors: []
      }
    }

    case tagsTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/tagsReducer.js